/**
* Converts a string in snake_case to PascalCase.
* 
* @param {string} str - The snake_case string to be converted.
* @returns {string} - The converted string in PascalCase.
*/
const snakeToPascal = (str) => {
  return str
    // Split the snake_case string into an array of words using '_' as a delimiter
    .split("_")
    // Iterate through the array of words and capitalize the first letter of each word
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    // Join the capitalized words back into a single string without any delimiter (PascalCase)
    .join("");
};

/**
* Converts a space separated string to camelCase.
* 
* @param {string} str - The space separated string to be converted.
* @returns {string} - The converted string in camelCase.
*/
function stringToCamelCase(str) {
// Split the string into words using ' ' as a delimiter
const words = str.split(' ');
// Convert the first word to lowercase
const result = [words[0].toLowerCase()];
// Convert the rest of the words to Title Case (remove spaces, first character uppercased, the rest lowercased)
for (let i = 1; i < words.length; i++) {
  result.push(words[i].charAt(0).toUpperCase() + words[i].slice(1).toLowerCase());
}
// Combine the words back into a single string
return result.join('');
}

/**
* Generates the href link for a given program item object based on its slug and type.
*
* @param {object} programItem - The program item object containing the slug and type.
*                              - Must have a __typename property that is either 'SeriesItem' or 'MovieItem', a slug property that contains the unique identifier for the program item, and have preventDetailPage set to a falsy value.
* @returns {string} - The href link for the program item, formatted as 'show/{slug}' for SeriesItems or 'movie/{slug}' for MovieItems.
*                    - An empty string is returned if programItem is undefined or does not have a valid type or slug.
*/
const generateHrefFromProgramSlug = (programItem) => {
if (programItem && (programItem.__typename === 'SeriesItem' || programItem.__typename === 'MovieItem') && programItem.slug && !programItem.preventDetailPage) {
  
  let href = ''
  switch (programItem.__typename) {
    case 'SeriesItem':
      href = 'show/' + programItem.slug;  
      break
    case 'MovieItem':
      href = 'movie/' + programItem.slug;
      break
    default:
      break
  }

  return href
}
return '';
}

/**
* Determines the alt text for an image associated with an object, based on the object's properties.
*
* @param {object} data - The object containing properties related to the image and alt text.
*                       - Must have an "omitAltText" property that is a boolean, an "altTextOverride" property that is a string or undefined, and an "image" property that is an array of image objects, with each object having an "alt" property that is a string or undefined.
* @returns {string} - The alt text for the image, determined based on the slide object's properties.
*                    - An empty string is returned if "omitAltText" is true, or none of the other conditions are met. 
*                    - The value of "altTextOverride" is returned if it is defined & truthy
*                    - Otherwise, the alt value associated with the image is returned if it is defined & truthy
*/
const setAltText = data => {
if (data?.altTextOverride) return data.altTextOverride;
if (data?.image?.[0]?.alt) return data.image[0].alt;

return '';
}

/**
* Determines if the current device is a touch device.
* 
* @returns {boolean} - True if the current device is a touch device, false otherwise.
*/
const isTouchDevice = () => {
return (('ontouchstart' in window) ||
  (navigator.maxTouchPoints > 0) ||
  (navigator.msMaxTouchPoints > 0));
}

/**
* Converts a time sting of the format "HH:MM" to
* a string formatted as "MM MIN"
* 
* @param {string} runTime 
* @returns {string} minutesStr
*/
const getMinutesFromStr = timeLenghtStr => {
const [hours, mins] = timeLenghtStr.split(':')  
const minutesStr = `${(Number.parseInt(hours, 10) * 60) + Number.parseInt(mins, 10)} MIN`;
    
return minutesStr
}

export {
snakeToPascal,
stringToCamelCase,
generateHrefFromProgramSlug,
setAltText,
isTouchDevice,
getMinutesFromStr,
}